// @flow

/**
 * Organisation Context
 * Provides organisation name for AI prompt components (e.g., dynamic helper text)
 */

import { createContext, useContext } from 'react';

export type OrganisationContextValue = {
  organisationName: string,
};

export const OrganisationContext = createContext<?OrganisationContextValue>(null);

/**
 * Hook to access organisation context
 * Returns null if not within a provider (graceful degradation)
 * @returns {OrganisationContextValue | null} Organisation context or null
 */
export function useOrganisation(): ?OrganisationContextValue {
  return useContext(OrganisationContext);
}
